export default "__VITE_ASSET__lJNZmJg5__"